import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  buttoncountcontainer: {
    marginTop: 15,
    marginBottom: 15
  },
  reload: {
    position: "absolute",
    right: "16px",
    top: "35px",
    cursor: "pointer",
    color: theme.palette.primary.main,
    "& svg": {
      color: theme.palette.primary.main,
      fill: theme.palette.primary.main
    }
  },
  selectcont: {
    textAlign: "left !important"
  },
  flexsub: {
    maxWidth: "560px",
    display: "flex",
    alignItems: "center",
    gap: "10px"
  },
  schedulecont: {
    maxWidth: "100%",
    marginTop: "16px",
    padding: "18px 12px",
    border: "1px solid #D0D5DD",
    borderRadius: "16px",
    TextAlign: "left !important",
    "& h1": {
      fontWeight: "700",
      fontSize: "16px",
      color: "#101928",
      marginBlock: "0px",
      TextAlign: "left"
    },
    "& h3": {
      fontWeight: "700",
      color: "#013EBA",
      fontSize: "14px"
    },
    "& p": {
      color: "#667185",
      fontSize: "14px",
      marginBlock: "0px 0px"
    },
    "& a": {
      textDecoration: "none"
    }
  },
  schdulecard: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "@media (max-width: 480px)": {
      flexDirection: "column",
      alignItems: "flex-start"
    }
  },
  firstitem: {
    fontWeight: "700"
  },
  modalFooterBtn: {
    display: "flex",
    width: "100%",
    gap: "10px",
    alignItems: "center",
    justifyContent: "center"
  },
  // Calendar Styling
  calendar: {
    "& h1": {
      marginBlock: "5px",
      fontSize: "18px",
      fontWeight: "600"
    },
    "& button": {
      backgroundColor: "white",
      boxShadow: "#D0D5DD 1px 1px 1px 1px",
      border: "0px solid black"
    },
    "& .fc-button-group": {
      gap: "4px"
    },
    "& .fc-toolbar": {
      marginTop: "10px"
    },
    "@media (max-width: 600px)": {
      "& h1": {
        fontSize: "14px"
      },
      "& .fc-toolbar": {
        flexWrap: "wrap",
        gap: "5px",
        justifyContent: "space-between"
      },
      "& .fc .fc-toolbar-title": {
        fontSize: "14px"
      }
    },
    "& .fc-button-primary": {
      backgroundColor: "white",
      color: "black",
      border: "none"
    },
    "& .fc-button-primary:disabled": {
      backgroundColor: "#F9FAFB",
      border: "none",
      color: "black"
    },
    "& .fc-button-primary:not(:disabled):active": {
      backgroundColor: "#F9FAFB",
      borderColor: "transparent",
      color: "black",
      outline: 0,
      border: "1px solid transparent"
    },
    "& .fc-button-primary:focus": {
      boxShadow: "#D0D5DD 1px 1px 1px 1px"
    },
    "& .fc-scrollgrid": {
      borderTop: "0px solid transparent",
      borderLeftWidth: "0px"
    },
    "& .fc table tr:first-child th": {
      border: "none",
      borderSpacing: 0,
      backgroundColor: "#F9FAFB",
      paddingTop: "10px",
      paddingBottom: "10px",
      fontSize: "14px",
      fontWeight: 400,
      marginLeft: "-1px"
    },
    "& .fc-theme-standard td:first-child": {
      borderLeft: "1px solid #ddd"
    },
    "& .fc-button-primary:hover": {
      backgroundColor: "transparent",
      color: theme.palette.primary.main
    },
    "& .fc-button-primary:active": {
      backgroundColor: "#F9FAFB",
      color: theme.palette.primary.main,
      outline: 0
    },
    "& .fc .fc-now-indicator-line": {
      borderColor: "red",
      height: "2px",
      borderWidth: "2px 0 0 0"
    },
    "& .fc .fc-daygrid-event": {
      borderLeftWidth: "3px",
      borderBottomLeftRadius: "8px",
      borderTopLeftRadius: "8px"
    },
    "& .fc .fc-now-indicator-arrow,.fc .fc-now-indicator-dots": {
      display: "none"
    }
  }
}));
